import { useNavigate } from 'react-router-dom'
import React, { useState, useEffect } from "react";
import { getAllCountries,updateOrganizer } from "../../../api";
import { colourStyles } from "../../../utils/customSelectStyle";
import { FaFacebookSquare, FaInstagram, FaTwitter, FaLinkedin, FaYoutube, FaGlobe } from "react-icons/fa";
import { images } from "../../../assets/images";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import Select from "react-select";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNightMode } from "../../../contexts/NightModeContext";
import Background from "../../Login/Background";
import PageHeader from "../../../components/common/PageHeader/PageHeader";
const ProfileEdit = () => {
    const { isNightMode } = useNightMode();
    const navigate = useNavigate();
    const [countries, setCountries] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [profileData, setProfileData] = useState<any>(null);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [selectedCountry, setSelectedCountry] = useState(profileData?.countryId || "");
    const toggle = () => {
        navigate("/profile");
    };
    useEffect(() => {
    const getCountries = async () => {
      try {
        const response = await getAllCountries();
        setCountries(response);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
    getCountries();
  }, []);
  useEffect(() => {
    const organizerData = localStorage.getItem("organizerData");
    if (organizerData) {
        const parsed = JSON.parse(organizerData);
        setProfileData(parsed); 
    }
    }, []);
  const formik = useFormik({
  enableReinitialize: true,
  initialValues: {
    firstName: profileData?.firstName || "",
    lastName: profileData?.lastName || "",
    bio: profileData?.bio || "",
    name: profileData?.name || "",
    email: profileData?.email || "",
    phone: profileData?.phone || "",
    url: profileData?.url || "",
    countryId: profileData?.countryId || "",
    address: profileData?.address || "",
    state: "",
    city: "",
    zipCode: "",
    facebook: profileData?.socialMedia?.find((item:any) => item.platform === "facebook")?.url || "",
    instagram: profileData?.socialMedia?.find((item:any) => item.platform === "instagram")?.url || "",
    youtube: profileData?.socialMedia?.find((item:any) => item.platform === "youtube")?.url || "",
    website: profileData?.socialMedia?.find((item:any) => item.platform === "website")?.url || "",
    profileImage: null,
    status: "active",
  },
  onSubmit: async (values) => {
    setIsLoading(true);
    try {
      const organizerData = localStorage.getItem("organizerData");
      if (organizerData) {
        const organizerId = JSON.parse(organizerData).organizerId;

        let data = new FormData();
        data.append("firstName", values.firstName);
        data.append("lastName", values.lastName);
        data.append("bio", values.bio);
        data.append("name", values.name);
        data.append("phone", values.phone);
        data.append("email", values.email);
        data.append("countryId", values.countryId);
        data.append("address", values.address);
        if (values.profileImage) {
          data.append("profilePic", values.profileImage);
        }
        data.append("status", values.status);
        const socialMedia = [
          { platform: "website", url: values.website },
          { platform: "facebook", url: values.facebook },
          { platform: "instagram", url: values.instagram },
          { platform: "youtube", url: values.youtube },
        ].filter(item => item.url); 
        data.append("socialMedia", JSON.stringify(socialMedia));
        const response = await updateOrganizer(organizerId, data);
        console.log("Updated successfully:", response);
        setProfileData(response.data);
        localStorage.setItem("organizerData", JSON.stringify(response.data));
        navigate("/profile", { state: { toastMessage: "Profile updated successfully" } });
        toggle();
      }
    } catch (error:any) {
    console.error("Update failed:", error);
    const errorMsg =
        error.response?.data?.message || "Failed to update organizer. Please try again.";
    toast.error(errorMsg);
} finally {
      setIsLoading(false);
    }
  },
});
    useEffect(() => {
    if (profileData?.countryId) {
        setSelectedCountry(String(profileData.countryId));
        console.log("Selected country ID:", profileData.countryId);
    }
    }, [profileData]);

  return (
    <div className={`contact-list-container ${isNightMode ? 'text-white' : 'text-dark'}`}>
      <Background />
      <ToastContainer />
      <PageHeader
        title="Edit Profile"
        subtitle="Update your organizer profile details, contact information, social links, and bio."
        isLoading={isLoading}
      />

      <div className="glass-panel p-4 mt-4" style={{ maxWidth: "800px", margin: "0 auto" }}>
        <Form onSubmit={formik.handleSubmit}>
          <div className="model-content main-form">
            <div className="row">
                            <div className="col-lg-12 col-md-12">
                           <div className="user-avatar-img align-items-center justify-content-center d-flex">
                                <div className="position-relative">
                                    <img
                                    src={previewUrl || profileData?.profilePic || images.profile }
                                    alt="profile"
                                    style={{ width: "120px", height: "120px", borderRadius: "50%", objectFit: "cover",backgroundColor: "#f0f0f0", }}
                                    />
                                    <div className="avatar-img-btn ">
                                    <input
                                        type="file"
                                        id="avatar-img"
                                        accept="image/*"
                                        style={{ display: "none" }}
                                        onChange={(e) => {
                                        const file = e.currentTarget.files?.[0];
                                        if (file) {
                                            formik.setFieldValue("profileImage", file);
                                            setPreviewUrl(URL.createObjectURL(file)); 
                                        }
                                        }}
                                    />
                                    <label htmlFor="avatar-img" className="d-flex align-items-center p-2">
                                        <i className="fa-solid fa-camera"></i>
                                    </label>
                                    </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-12 col-md-12">
                                <div className="form-group mt-4">
                                    <label className="form-label">Organizer*</label>
                                    <input
                                    className="form-control h_40"
                                    type="text"
                                    name="name"
                                    onChange={formik.handleChange}
                                    value={formik.values.name}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="form-group mt-4">
                                    <label className="form-label">First Name*</label>
                                    <input
                                    className="form-control h_40"
                                    type="text"
                                    name="firstName"
                                    onChange={formik.handleChange}
                                    value={formik.values.firstName}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="form-group mt-4">
                                    <label className="form-label">Last Name*</label>
                                    <input
                                    className="form-control h_40"
                                    type="text"
                                    name="lastName"
                                    onChange={formik.handleChange}
                                    value={formik.values.lastName}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12">
                                <div className="form-group mt-4">
                                    <label className="form-label">Bio*</label>
                                    <textarea
                                    className="form-textarea"
                                    name="bio"
                                    onChange={formik.handleChange}
                                    value={formik.values.bio}
                                    ></textarea>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="form-group mt-4">
                                    <label className="form-label">Email*</label>
                                    <input
                                    className="form-control h_40"
                                    type="text"
                                    name="email"
                                    readOnly
                                    onChange={formik.handleChange}
                                    value={formik.values.email}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="form-group mt-4">
                                    <label className="form-label">Phone*</label>
                                    <input
                                    className="form-control h_40"
                                    type="text"
                                    name="phone"
                                    onChange={formik.handleChange}
                                    value={formik.values.phone}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="form-group mt-4">
                                    <label className="form-label">Website*</label>
                                    <input
                                    className="form-control h_40"
                                    type="text"
                                    name="website"
                                    onChange={formik.handleChange}
                                    value={formik.values.website}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="form-group mt-4">
                                    <label className="form-label">Facebook*</label>
                                    <input
                                    className="form-control h_40"
                                    type="text"
                                    name="facebook"
                                    onChange={formik.handleChange}
                                    value={formik.values.facebook}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="form-group mt-4">
                                    <label className="form-label">Instagram*</label>
                                    <input
                                    className="form-control h_40"
                                    type="text"
                                    name="instagram"
                                    onChange={formik.handleChange}
                                    value={formik.values.instagram}
                                    />
                                </div>
                            </div>
                            {/* <div className="col-lg-6 col-md-12">
                                <div className="form-group mt-4">
                                    <label className="form-label">Twitter*</label>
                                    <input
                                    className="form-control h_40"
                                    type="text"
                                    name="twitter"
                                    onChange={formik.handleChange}
                                    value={formik.values.twitter}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="form-group mt-4">
                                    <label className="form-label">LinkedIn*</label>
                                    <input
                                    className="form-control h_40"
                                    type="text"
                                    name="linkedin"
                                    onChange={formik.handleChange}
                                    value={formik.values.linkedin}
                                    />
                                </div>
                            </div> */}
                            <div className="col-lg-6 col-md-12">
                                <div className="form-group mt-4">
                                    <label className="form-label">Youtube*</label>
                                    <input
                                    className="form-control h_40"
                                    type="text"
                                    name="youtube"
                                    onChange={formik.handleChange}
                                    value={formik.values.youtube}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="form-group mt-4">
                                    <label className="form-label">Address*</label>
                                    <input
                                    className="form-control h_40"
                                    type="text"
                                    name="address"
                                    onChange={formik.handleChange}
                                    value={formik.values.address}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="form-group mt-4">
                                    <label className="form-label">Country*</label>
                        

                               <Input
                                    type="select"
                                    name="countryId"
                                    value={formik.values.countryId}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.countryId && !!formik.errors.countryId}
                                    >
                                    <option value="">Select Country</option>
                                    {countries.map((c:any) => (
                                        <option key={c.countryId} value={c.countryId}>
                                        {c.countryName}
                                        </option>
                                    ))}
                                    </Input>
                                    {formik.touched.countryId && formik.errors.countryId && (
                                    <div className="text-danger mt-1"> {typeof formik.errors.countryId === "string"}</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                <div className="modal-footer">
                    <button type="button" className="co-main-btn min-width btn-hover h_40 m-4" 
                    onClick={() =>
                        navigate("/profile")} >
                        Cancel
                    </button>
                        <button
                        type="submit"  
                        className="main-btn min-width btn-hover h_40 m-4"
                        disabled={isLoading} 
                        >
                        {isLoading ? "Updating..." : "Update"}
                        </button>
                </div>
            </Form>
          </div>
        </div>
  );
};
export default ProfileEdit;
